import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography, Button, TextField, Table, TableBody, TableCell,
    TableHead, TableRow, TableContainer, Paper, Pagination, Stack, Box, Tooltip
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


import { useAppContext } from "../context/AppContext"
import { useAuth } from '../context/AuthContext';
import { ADMIN_ROLE, ORG_MANAGER_ROLE } from '../context/AuthContext';

const Users = () => {

    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    // const [name, setName] = useState('');
    const [searchString, setSearchString] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [copiedId, setCopiedId] = useState(null);
    const itemsPerPage = 5;
    const { getBRIS, postEnableUser, postDisableUser } = useAppContext();
    const { role  } = useAuth();

    const fetchUsers = async (pageNumber, pageSize, search = '') => {
        try {
            const response = await getBRIS(pageNumber, pageSize, search);
            const items = Array.isArray(response?.items) ? response.items : [];

            setUsers(items);
            setCurrentPage(Number(response?.pageNumber || pageNumber));
            setTotalPages(Number(response?.totalPages || 0));
        } catch (error) {
            console.error('Error fetching users:', error);
            setUsers([]);
            setTotalPages(0);
        }
    };

    useEffect(() => {
        fetchUsers(currentPage, itemsPerPage, searchString);
    }, [currentPage, searchString]);

    useEffect(() => {
        console.log("users", users);
    }, [users]);

    const handleEdit = (user) => {
        // Navigate to the user edit page
        navigate(`/users/${user.id}/update`);
    };

    const handleView = (user) => {
        // Navigate to the user view page
        navigate(`/user/${user.id}`);
    };

    const handleSubmit = () => {
        console.log("handleSubmit")
    };

    const handIeInitialize = (user) => {
        navigate(`/users/${user.id}/initialize`);
    };

    const paginated = users;

    const handleEnable = async (user) => {
        try {
            const response = await postEnableUser(user.id);
            fetchUsers(currentPage, itemsPerPage);

        } catch (error) {
            console.error('Error enabling user:', error);
        }
    }

    const handleDisable = async (user) => {
        try {
            const response = await postDisableUser(user.id);
            fetchUsers(currentPage, itemsPerPage);
        } catch (error) {
            console.error('Error disabling user:', error);
        }
    }

    const handleCopyId = (id, e) => {
        if (e) {
            e.stopPropagation();
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(id).then(() => {
                setCopiedId(id);
                setTimeout(() => setCopiedId(null), 2000);
            }).catch(err => {
                console.error('Error copying to clipboard:', err);
                fallbackCopy(id);
            });
        } else {
            fallbackCopy(id);
        }
    }

    const fallbackCopy = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
            setCopiedId(text);
            setTimeout(() => setCopiedId(null), 2000);
        } catch (err) {
            console.error('Fallback copy failed:', err);
        }
        document.body.removeChild(textarea);
    }

    const getLastConsumerName = (user) => {
        const path = user?.consumerNamesPath;

        if (Array.isArray(path) && path.length > 0) {
            return path[path.length - 1] ?? '';
        }

        if (typeof path === 'string') {
            return path;
        }

        return '';
    };

    return (
        <>
            <Typography variant="h5">Bussiness Relations</Typography>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
                <Box sx={{
                    flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2
                }}>
                    <TextField label="Name" value={searchString} onChange={e => setSearchString(e.target.value)} />
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        {"Search"}
                    </Button>
                </Box>
                <Box>
                    {role.includes(ORG_MANAGER_ROLE) && (
                    <Button
                        variant="contained"
                        onClick={() => navigate('/create-user')}
                    >
                        Create User
                    </Button>

                    )}
                </Box>
            </Stack>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>BRI ID</TableCell>
                            <TableCell>Credential</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginated.map(user => (
                            <TableRow key={user.bri_id}>
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>{user.bri_id}</Typography>
                                        <Tooltip title={copiedId === user.bri_id ? "Copied!" : "Click to copy"}>
                                            <span>
                                                <ContentCopyIcon
                                                    onClick={(e) => handleCopyId(user.bri_id, e)}
                                                    sx={{
                                                        fontSize: 16,
                                                        color: 'rgb(51, 184, 177)',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            opacity: 0.7,
                                                        },
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>{user.user_management_username}</Typography>
                                        
                                    </Box>
                                </TableCell>
                                <TableCell
                                >
                                    <Typography sx={{ fontWeight: 'bold' }}>
                                        {getLastConsumerName(user)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {user.user_management_username !== null ? (
                                        <>
                                            <Button variant="outlined" onClick={() => {
                                                if (user.user_management_username !== null) {
                                                    handleEdit(user)
                                                }
                                            }}>Modify</Button>
                                            {user.enabled ? (
                                                <Button variant="outlined" onClick={() => {
                                                    handleDisable(user)
                                                }}>Disable</Button>
                                            ) : (
                                                <Button variant="outlined" onClick={() => {
                                                    handleEnable(user)
                                                }}>Enable</Button>
                                            )}
                                        </>
                                    ) : (
                                        <Button
                                            variant="outlined"
                                            onClick={() => handIeInitialize(user)}
                                            startIcon={<WarningAmberIcon />}
                                            sx={{
                                                color: '#f57c00', // Yellow-orange color
                                                borderColor: '#f57c00', // Border color
                                                '&:hover': {
                                                    backgroundColor: '#ffe0b2', // Light yellow background on hover
                                                    borderColor: '#f57c00',
                                                },
                                            }}
                                        >
                                            Initialize
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                sx={{
                    mt: 2, display: 'flex', justifyContent: 'center',
                    '& .MuiPaginationItem-root': {
                        color: 'white',
                        backgroundColor: 'secondary.main',
                        '&.Mui-selected': {
                            backgroundColor: 'secondary.dark',
                        },
                        '&:hover': {
                            backgroundColor: 'secondary.light',
                        },
                    },
                }}
            />
        </>
    );
};

export default Users;
